import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import SiteLayout from "@/components/site/SiteLayout";
import HomePage from "@/pages/HomePage";
import HighIncomePage from "@/pages/HighIncomePage";
import FundPage from "@/pages/FundPage";
import ChatPage from "@/pages/ChatPage";
import SharePage from "@/pages/SharePage";
import AdminPage from "@/pages/AdminPage";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<SiteLayout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/high-income-shares/" element={<HighIncomePage />} />
          <Route path="/high-income-shares/:slug/" element={<FundPage />} />
          <Route path="/etf/:slug/" element={<FundPage />} />
        </Route>
        <Route path="/chat" element={<ChatPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/share/:id" element={<SharePage />} />
      </Routes>
      <Toaster position="top-center" />
    </BrowserRouter>
  );
}
